export default "__VITE_ASSET__U_EhgIF___"